
import styled from 'styled-components';

const ClaroPadding = styled.div`
    padding: ${props => props.padding ? props.padding : "0rem 0rem 0rem 0rem"};
    display: ${props => props.display ? props.display : "block"};
    text-align: ${props => props.align ? props.align : "left"};
    ;

`

export default ClaroPadding;